import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../lib/api";
import useSeo from "../hooks/useSeo";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);

    useSeo({
        title: "Forgot Password | IDCardGen",
        description: "Reset your IDCardGen password by email.",
        noindex: true,
    });

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post("/auth/forgot-password", { email });
            setSent(true);
        } catch (err) {
            toast.error(
                err.response?.status === 429
                    ? "Too many requests. Please wait a minute and try again."
                    : err.response?.data?.error || err.message,
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center p-6" data-testid="forgot-password-page">
            <div className="w-full max-w-sm space-y-5">
                <div>
                    <h1 className="font-display font-black text-3xl tracking-tighter">Forgot password?</h1>
                    <p className="text-sm text-zinc-500 mt-1">
                        Enter your registered email and we'll send you a link to set a new password.
                    </p>
                </div>
                {sent ? (
                    <div className="border border-emerald-200 bg-emerald-50 p-4 text-sm text-emerald-800" data-testid="forgot-password-sent">
                        If an account exists for <b>{email}</b>, a reset link is on its way. It works for 60 minutes —
                        check your Spam folder if you don't see it.
                    </div>
                ) : (
                    <form onSubmit={onSubmit} className="space-y-5">
                        <div>
                            <label className="label-swiss">Email</label>
                            <input
                                type="email"
                                className="input-swiss"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                autoComplete="email"
                                required
                                data-testid="forgot-email-input"
                            />
                        </div>
                        <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="forgot-submit-btn">
                            {loading ? "Sending…" : "Send reset link"}
                        </button>
                    </form>
                )}
                <p className="text-sm text-zinc-500">
                    Remembered it?{" "}
                    <Link to="/login" className="text-blue-600 hover:underline">
                        Back to sign in
                    </Link>
                </p>
            </div>
        </div>
    );
}
